import { apiClient } from "@/lib/api-client";
import type { ApiKey, CreateApiKeyResponse } from "@/features/apikeys/types";

export const apiKeysApi = {
  list: () => apiClient.get<ApiKey[]>("/v1/api-keys"),
  create: (name: string) =>
    apiClient.post<CreateApiKeyResponse>("/v1/api-keys", { name: name || undefined }),
  revoke: (id: string) => apiClient.delete(`/v1/api-keys/${id}`),
};
